module.exports = __webpack_public_path__ + "img/DW365-083.f1982838.jpg";